import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import axios from './utils/request.js'
import createPersistedState from 'vuex-persistedstate'

export default new Vuex.Store({
  state: {
    token: null,
    authStatus: ""
  },
  getters: {
    isAuthenticated: state => !!state.token,
  },
  mutations: {
    authSuccess: function(state, token){
      state.token = token;
      state.authStatus = "success"
    },
    authFailed: function(state){
      state.authStatus = "error"
    },
    authReset: function(state){
      state.authStatus = ""
    },
    authLogout: function(state){
      state.token = null
      state.authStatus = ""
    }
  },
  actions: {
    login: function(context, auth) {

      context.commit("authReset")

      axios.post("/api/login", auth)
      .then((response => {
        context.commit("authSuccess", response.data.token)
      }))
      .catch(() => {
        context.commit("authFailed")
      })
    },
    logout: function(context){
      context.commit("authLogout")
    }
  },
  plugins: [createPersistedState()]
})
